import type { TerritoryRuleMetadata } from '../types/catalog';
import { CardImage } from './CardImage';
import { MapIcon } from './Icons';
import { CategoryBadge } from './Badges';

/** Cartão de um território com arte, categoria e regra. */
export function TerritoryTile({ territory }: { territory: TerritoryRuleMetadata }): React.JSX.Element {
  return (
    <article className="territory-tile">
      <div className="territory-art">
        <CardImage artUrl={territory.artUrl} alt={territory.name} glyph={<MapIcon />} />
        <span className="cat-badge">
          <CategoryBadge category={territory.category} />
        </span>
      </div>
      <div className="territory-body">
        <h3>{territory.name}</h3>
        <p>{territory.description}</p>
      </div>
    </article>
  );
}
